module.exports = __webpack_public_path__ + "img/card_home2.1ce5c870.svg";